import {injectable} from "inversify";
import {CountryEnum, RegionEnum} from "@/modules/base/enums";
import names from '@/modules/team/resources/names.json';
import chance from "@/modules/base/services/chance";

@injectable()
export default class NameGenerator {
  public generate(country: CountryEnum, region?: RegionEnum) {
    // @ts-ignore
    const data = names[country] || names.GB; // todo make fallback based on region
    let firstName = chance.pickone(data.first) as string;
    let lastName = chance.pickone(data.last) as string;

    if (firstName.length <= 3) {
      firstName += ' ' + (chance.pickone(data.first) as string);
    }

    if (lastName.length <= 3) {
      lastName += ' ' + (chance.pickone(data.last) as string);
    }

    return `${firstName} ${lastName}`;
  }
}
